var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00B0A0",
    d: "M3.063.5v.563H.813v12.374h12.374V1.063h-2.25V.5H9.813v.563H4.186V.5H3.063ZM1.937 2.188h1.125v.562h1.126v-.563h5.625v.563h1.124v-.563h1.126v1.126H1.937V2.187Zm0 2.25h10.126v7.875H1.937V4.436Zm3.375 1.125v1.125h1.125V5.563H5.313Zm2.25 0v1.125h1.125V5.563H7.563Zm2.25 0v1.125h1.126V5.563H9.812Zm-6.75 2.25v1.125h1.126V7.812H3.063Zm2.25 0v1.125h1.125V7.812H5.313Zm2.25 0v1.125h1.125V7.812H7.563Zm2.25 0v1.125h1.126V7.812H9.812Zm-6.75 2.25v1.124h7.876v-1.124H3.061Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGreen);
export default __webpack_public_path__ + "static/media/calendarGreen.93fe72d0cbce25c8881218fe935479c4.svg";
export { ForwardRef as ReactComponent };